import { render, staticRenderFns } from "./DataSourceSelect.vue?vue&type=template&id=815bf944&scoped=true&"
import script from "./DataSourceSelect.vue?vue&type=script&lang=js&"
export * from "./DataSourceSelect.vue?vue&type=script&lang=js&"
import style0 from "./DataSourceSelect.vue?vue&type=style&index=0&id=815bf944&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815bf944",
  null
  
)

export default component.exports